export type ParsedAdjustedQty = number | null | 'NEGATIVE' | 'INVALID';

/**
 * Parses raw input into an adjusted qty. Returns null for an empty input,
 * 'NEGATIVE' if negative, 'INVALID' if non-numeric.
 *
 * Accepts `number` as well as text: web's variance-adjust editor uses `<input
 * type="number">`, whose Angular `NumberValueAccessor` emits a NUMBER (or null)
 * through `ngModelChange`, not a string. Coerce with `String(...)` before trimming —
 * calling `.trim()` on a number throws `(raw ?? '').trim is not a function` and
 * aborts the save before the PATCH is ever sent (the observed web bug). Mobile
 * TextFields still pass strings; both flow through this one gate.
 */
export function parseAdjustedQty(
  raw: string | number | null | undefined
): ParsedAdjustedQty {
  const text = String(raw ?? '').trim();
  if (text === '') return null;
  const parsed = Number(text);
  if (Number.isNaN(parsed)) return 'INVALID';
  if (parsed < 0) return 'NEGATIVE';
  return parsed;
}
